module.exports = __webpack_public_path__ + "static/media/56.34f561c1.png";